class YoursizeSelectController {
    /*@ngInject*/
    constructor($log, $rootScope, YoursizeService) {
        $log.debug('YoursizeSelectController initialized');
        this.$log = $log;
        this.yoursizeService = YoursizeService;
        this.avatar = {};
        this.avatars = [];
        this.match = null;
        this.widget = null;
        this.hide = true;

        $rootScope.$on('personalizeRequestSuccess', () => {
            this.hide = false;
        });

        $rootScope.$on('fetchAvatarsDone', () => {
            this.avatars = this.yoursizeService.getAvatars();
            this.avatar = this.yoursizeService.getSelectedAvatar();
            if (this.avatar != {}) {
                this.match = this.avatar.match;
                this.widget = this.avatar.widget;
            }
        });
    }

    isHidden() {
        return this.hide;
    }

    isEnabled() {
        return this.yoursizeService.isEnabled();
    }

    isLoggedIn() {
        return this.yoursizeService.isLoggedIn();
    }

    setCurrentAvatar(avatar) {
        this.yoursizeService.matchAvatar(avatar);
    }

    isAvatarSelected() {
        if (typeof this.yoursizeService.getSelectedAvatar().avatar === "undefined") {
            return false;
        } else {
            return true;
        }
    }

    getAvatars() {
        return this.avatars;
    }

    hasMatch() {
        if (this.match === null) {
            $('.yoursize-suggestion').html('');
            return false;
        }
        else {
            try {
                $('.yoursize-suggestion').html(this.avatar.match.size);
                return true;
            }
            catch (e) {
                $('.yoursize-suggestion').html('');
                return false;
            }
        }
    }

    getWidgetHtml() {
        document.getElementById('productFitTabiFrame').src ="data:text/html;charset=utf-8,"+this.widget.htmlSnippet;
    }
}

export default YoursizeSelectController;
